"use client";

import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import * as React from "react";

interface IProps extends React.SuspenseProps {
  unless?: boolean;
}

/**
 * Thin wrapper around React.Suspense that omits it when
 * the `unless` prop is true.
 * Primarily needed for SSR compatibility.
 */
export const Suspense: React.FC<IProps> = (props: IProps) => {
  const isSSR = useIsSSR();
  const { unless = isSSR, children, fallback, ...otherProps } = props;
  if (unless) {
    return <>{children}</>;
  }
  return (
    <React.Suspense fallback={fallback} {...otherProps}>
      {children}
    </React.Suspense>
  );
};
